module.exports = __webpack_public_path__ + "static/media/COS_PHILIPS_AVENT.0d8c6b41.png";